import templateRegistry from "../Registry/index.js";
import PreviewOrgNavbar from "./PreviewOrgNavbar.jsx";

function FullPagePreview({ pageData }) {
  const templateId =
    pageData?.page?.template_id || "default-homepage";

  const TemplateComponent =
    templateRegistry[templateId]?.publicComponent ||
    templateRegistry["default-homepage"]?.publicComponent ||
    null;

  return (
    <div className="full-preview-shell">
      <PreviewOrgNavbar pageData={pageData} />

      {TemplateComponent ? (
        <TemplateComponent
          pageData={pageData}
          organization={pageData?.organization}
          page={pageData?.page}
          settings={pageData?.settings}
        />
      ) : null}
    </div>
  );
}

export default FullPagePreview;